import React, { useEffect, useRef, useState } from 'react'
import { Button } from '../../../Components/Helper'
import { ROUTES } from '../../../routes'
import { capitalizeFirstLetter, reduceLongName, squareKilometersToAcres } from '../../../ReusableFunctions/reusableFunctions'
import { AEROMEGH_SERVICES, STATUS, STATUS_MESSAGES } from '../../../appConstants'
import dateFormat from 'dateformat';
import useWindowSize from '../../../hooks/useWindowSize'
import MainContentWrapper from '../../../Components/MainContentWrapper'
import { useLocation, useNavigate } from 'react-router'
import VerticalStepper from '../../../ReusableComponents/VerticalStepper'
import { cancelRequest, getRequest } from '../../../apis/requests'
import RequestDiscount from '../../../ReusableComponents/RequestDiscount'
import Loading from '../../../ReusableFunctions/Loader'
import L from 'leaflet'
import roadMapView from '../../../assets/roadMapView.png'
import sateliteView from '../../../assets/sateliteView.png'
import Map from "../../../features/LeafletMap/Map"
import Popup from "../../../ReusableFunctions/Popup";
import MarkerIcon from "../../../assets/marker.png";
import { MAP_URLS } from "../../../appConstants";
import fullScreenIcon from '../../../assets/fullScreenIcon.png';
import collapseIcon from '../../../assets/collapse.png';
import pilotIcon from "../../../assets/pilot.svg";
import TableView from '../../../ReusableComponents/TableView/TableView'
import { getTelecallingHistory } from '../../../apis/BhuMeetTeams/Telecaller/dashboard'
import { AddcallHistory } from '../../../BhuMeetTeams/BhumeetTeleCaller/createCallHistory'
import { useSelector } from 'react-redux'
import { CallHistoryTable } from '../../../BhuMeetTeams/BhumeetTeleCaller/callHistoryTable'
import { getCallhistorybyCampid, InitiateCall, updateCallingHistoryStatus } from '../../../apis/BhuMeetTeams/Telecaller/callingHistory'
import { getCallreport } from '../../../apis/BhuMeetTeams/Telecaller/requestqueue'
import { CreateRequestIssue } from '../../../BhuMeetTeams/BhumeetTeleCaller/createRequestIssue'
import { MenuItem, Select } from '@mui/material'
import { getAllRequestIssueByRequestID } from '../../../apis/BhuMeetTeams/Oparations/requestIssue'
import SelectComponent from '../../../ReusableComponents/SelectComponent'
import OrderCancelModal from '../../../BhuMeetTeams/Operations/reusableComponents/CancelOrderModal'

let baseLayer;

const ViewRequestDetails = () => {
    const userDetails = useSelector(state => state.user?.user)

    const { state } = useLocation();
    const {currentWidth}=useWindowSize();
    const [steps, setSteps] = useState([])
    const [request, setRequest] = useState({})
    const navigate = useNavigate();
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const isTrainingService = state.request?.type === AEROMEGH_SERVICES.TRAINING
    const isSprayingService = state.request?.type === AEROMEGH_SERVICES.SPRAYING;
    const isSurveyService = state.request?.type === AEROMEGH_SERVICES.SURVEY;
    const [activeBaseLayer, setActiveBaseLayer] = useState(baseLayer)
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [opencallHistory, setopencallHistory] = useState(false);
    const { pathname } = useLocation();
    const [refresh, setRefresh] = useState(0);
    const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);
    const [showCancelButton, setShowCancelButton] = useState(false);

    const [selectedIssue, setSelectedIssue] = useState("");
    const [center, setCenter] = useState(
        { lat: 19.993982, lng: 73.790416 }
    );
    const [callHistory, setcallHistory] = useState([]);
    const mapContainerRef = useRef(null);
    const [map, setMap] = useState(null)

    const [fieldData, setFieldData] = useState([]);

    const [campid, setCampid] = useState(null)
    const [lastRecord, setlastRecord] = useState(false)
    const [callActive, setCallActive] = useState(false)
    const [dspCallActive, setDspCallActive] = useState(false)
    const [PilotCallActive, setPilotCallActive] = useState(false)
    const [createIssue, setCreateIssue] = useState(false)
    const [AllrequestIssue, setAllrequestIssue] = useState([])
    const [comments, setComments] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const{user}=useSelector((state)=>state.user);

    const checkExistingCalls = (data, refresh) => {
        console.log(data)
        console.log(state.request)
        let Count = data.filter(x => {
            return x.callingQueueID === state.request.Data.queueid && x.current_req_status === state.request.Data.current_req_status
        })
        // console.log(Count)
        if (Count.length >= 2) {
            setlastRecord(true)
            if (refresh) setRefresh((prev) => prev + 1);

            return true
        } else {
            setlastRecord(false)
            return false
        }
    }

    const getAllRequestIssueByID = async (reqID) => {
        try {
            let role = userDetails.bhumeet_role == 'Admin' ? 'operations' : userDetails.bhumeet_role == 'Telecaller' ? 'telecaller' : 'customerSuccessEngineer'
            getAllRequestIssueByRequestID(reqID, role).then(res => {
                console.log(res)
                setAllrequestIssue(res)
            }).catch(err=>{
                return Popup.alert("WARNING","Something Went Wrong","WARNING")
            })
        } catch (err) {

            console.error(err)

        }
    }

    const cancelRequestFunction = async (requestId, note, isDebitBESIncentive) => {
        try {
            const updatedRequest = await cancelRequest(requestId, note, isDebitBESIncentive)
            setOpenCancelOrderModal(false);
            getRequestDetails()
            Popup.alert("Request cancelled", "Request successfully cancelled!", 'SUCCESS',)
        } catch (e) {
            Popup.alert("Error", e, "ERROR");
        }
    }

    useEffect(() => {
        // console.log(campid)
        setRefresh((prev) => prev + 1);

    }, [campid])


    const handleCallClick = (contactValue,label) => {
        console.log(contactValue,label)
        if (contactValue) {


            let check = state.request.Data ?  checkExistingCalls(callHistory) : null
            // console.log(check)
            let role = label === 'Contact No.' ? 'Customer' : label === 'DSP Name' ? 'dsp' : label === 'Pilot' ? 'pilot' : null
            if (!check) {
                if(label === 'Contact No.'){
                    setCallActive(true)
                }else if(label === 'DSP Name'){
                    setDspCallActive(true)
                }else if(label === 'Pilot'){
                    setPilotCallActive(true)
                }
                InitiateCall(Number(contactValue), state.request.Data || {assignee:userDetails.id,reqid:state.request.id}, userDetails.phone,role).then(res => {
                    // console.log(res)


                    checkCallReport(res.callDetail.campid)

                    return Popup.alert("SUCCESS", res.message, "SUCCESS")
                }).catch(err => {
                    console.log(err)
                    setCallActive(false)
                    setDspCallActive(false)
                    setPilotCallActive(false)

                    return Popup.alert("ERROR", err, "ERROR")
                })
            }
            // setlastRecord(false)


            // You can integrate further logic like API calls, etc.
        } else {
            return Popup.alert("ERROR", "No contact number available.", "ERROR")

        }


    };

    const Field = ({ label, value, overflow, onCallClick }) => {
        const isContactNo = label === "Contact No.";
        const isDSPName = label === "DSP Name";
        const isPilot = label === "Pilot";
        // console.log(label,value)
        return (
            <div className="single_field_wrapper" style={{ lineHeight: overflow ? 1.15 : 1.1 }}>
        {(isContactNo && (userDetails.bhumeet_role === 'Telecaller' || userDetails.bhumeet_role === 'Customer support engineer') && request?.user?.id) ? (
            <>
                <div className='single_field_label'>{label}</div>
                <Button
                    style={{ whiteSpace: "nowrap", marginBottom: "5px", width: "100px" }}
                    type="submit"
                    isDisabled={callActive || lastRecord}
                    text={callActive ? "Call InProgress" : "Click to Call"}
                    onClick={() => onCallClick(request.user_phone,'Contact No.')}
                />
            </>
        ) : (
            <div
                className='single_field_wrapper'
                onClick={() => {
                    if ((label === "Customer Name" || label === "Contact No.") && userDetails.bhumeet_role !== 'Telecaller') {
                        if (!request?.user?.id) return;
                        navigate('/userDetails', { state: { user: request.user } });
                    }
                }}
                style={{
                    cursor: ((label === "Customer Name" && userDetails.bhumeet_role !== 'Telecaller') || label === "Contact No.")
                        ? "pointer" : "default",
                    lineHeight: overflow ? 1.15 : 1.1
                }}
            >
                <div className='single_field_label'>{label}</div>
                <div className='single_field_value' style={{
                    maxHeight: overflow && value?.length > 120 ? "100px" : "none",
                    overflowY: overflow && value?.length > 120 ? "auto" : "hidden"
                }}>
                    {value || "-"}{" "}
                    {(isDSPName && value != '-'&& userDetails.bhumeet_role !== 'Telecaller' && state.request.show  && request.user?.id )  && (
                        <a
                        href="#"
                        style={{
                        marginLeft: '10px',
                        color: dspCallActive ? 'gray' : '#007bff',
                        textDecoration: dspCallActive ? 'none' : 'underline',
                        pointerEvents: dspCallActive ? 'none' : 'auto',
                        cursor: dspCallActive ? 'not-allowed' : 'pointer'
                        }}
                        onClick={(e) => {
                        e.preventDefault();
                        if (!dspCallActive) {
                        console.log(request);
                        onCallClick(request.dsp.phone, 'DSP Name');
                        }
                        }}
                        >
                            {dspCallActive ? "Calling..." : "Click to Call"}
                        </a>
                    )}
                    
                    {(isPilot && value != '-' && userDetails.bhumeet_role !== 'Telecaller'&&  state.request.show && request?.user?.id) && (
                        <a
                        href="#"
                        style={{
                        marginLeft: '10px',
                        color: PilotCallActive ? 'gray' : '#007bff',
                        textDecoration: PilotCallActive ? 'none' : 'underline',
                        pointerEvents: PilotCallActive ? 'none' : 'auto',
                        cursor: PilotCallActive ? 'not-allowed' : 'pointer'
                        }}
                        onClick={(e) => {
                        e.preventDefault();
                        if (!PilotCallActive) {
                        // console.log(request);
                        onCallClick(request.pilot_mobile_number, 'Pilot');
                        }
                        }}
                        >
                            {PilotCallActive ? "Calling..." : "Click to Call"}
                        </a>
                    )}
                </div>
            </div>
        )}
    </div>
        );
    };

    const checkCallReport = async (campid) => {
        try {

            const interval = setInterval(async () => {
                const CallReport = await getCallreport()

                let findspecificCall = CallReport.filter(x => x.sid_id == campid)

                if (findspecificCall[0]?.sid_id) {
                    // console.log("Found",findspecificCall)
                    setCampid(findspecificCall[0]);
                    // setlastRecord(true)
                    setRefresh((prev) => prev + 1);

                    // Stop further executions as the condition is met
                    setCallActive(false)
                    setDspCallActive(false)
                    clearInterval(interval)


                }

            }, 5000)


        } catch (err) {
            console.log(err)

        }
    }

    const getRequestDetails = async () => {
        let requestData = await getRequest({ type: state.request.type ||AEROMEGH_SERVICES.SPRAYING, id: state.request.id }, true, true,true,true)

        setRequest({ ...request, ...requestData.request })
        setRequest((prev) => ({ ...prev, type: prev.invoice.request_type }))

        if (requestData.request.status === 'Placed') {
            setIsButtonVisible(true)
        } else {
            setIsButtonVisible(false)
        }
        setComments(()=>requestData?.request?.comments)
        setSteps(requestData.request.status_history.map(record => {
            return {
                label: record.updated_status,
                content: <>
                    <div style={{
                        color: "rgb(59, 59, 59)",
                        fontSize: "13px",
                        fontWeight: "500",
                        wordBreak: "break-word",
                        marginBottom: "0px",
                    }}>{record.updated_status == STATUS.PLACED ? STATUS_MESSAGES.PLACED :
                        record.updated_status == STATUS.ACCEPTED ? STATUS_MESSAGES.ACCEPTED :
                            record.updated_status == STATUS.RESCHEDULED ? STATUS_MESSAGES.RESCHEDULED :
                                record.updated_status == STATUS.OUT_FOR_SERVICE ? STATUS_MESSAGES.OUT_FOR_SERVICE :
                                    record.updated_status == STATUS.INPROGRESS ? STATUS_MESSAGES.INPROGRESS :
                                        record.updated_status == STATUS.COMPLETED ? STATUS_MESSAGES.COMPLETED :
                                            record.updated_status == STATUS.PAID ? STATUS_MESSAGES.PAID :
                                                record.updated_status == STATUS.CANCELLED ? STATUS_MESSAGES.CANCELLED :
                                                    record.updated_status == STATUS.HOLD ? STATUS_MESSAGES.HOLD :
                                                        ""
                        }</div>
                    {record?.note && <div style={{ lineHeight: '16px', margin: '5px 0px', fontSize: '13px', }}>
                        <span style={{ marginRight: '3px', fontWeight: 500, }}>Note :</span><span style={{ color: "#3b3b3b", fontWeight: 500 }}>{record.note}</span>
                        <br />
                        {(record.updated_status===STATUS.CANCELLED && requestData?.request?.cancelledRequestDetails) && <div className='mt-1'>Cancelled By:{requestData?.request?.cancelledRequestDetails?.user_name}</div>}
                        {(record.updated_status===STATUS.CANCELLED && requestData?.request?.cancelledRequestDetails) && <div className='mt-1'>User Role:{requestData?.request?.cancelledRequestDetails?.user_role}</div>}
                    </div>}
                    <div style={{ color: "#727272", fontSize: "13px", fontWeight: "600" }}>{`${dateFormat(new Date(record.time), "h : MM TT")}, ${dateFormat(new Date(record.time), "d mmmm yyyy")}`}</div>
                </>,
                statusColor: record.updated_status == STATUS.RESCHEDULED ? "#E27444" : record.updated_status == STATUS.CANCELLED ? "#EB0000" : "#32B338",
                highlightStatus: record.updated_status == STATUS.RESCHEDULED || record.updated_status == STATUS.CANCELLED
            }
        }))
    }
    const markerIcon = L.icon({
        iconUrl: MarkerIcon,
        iconSize: [24, 32],
    });
    const PilotIcon = L.icon({
        iconUrl: pilotIcon,
        iconSize: [30, 36],
    });

    const initMap = (map) => {
        setMap(map)
        // console.log(request)

    };



    const switchBaseLayer = () => {
        const activeLayer = activeBaseLayer == "satelite" ? "terrain" : "satelite"
        setActiveBaseLayer(activeLayer)
        if (baseLayer) {
            baseLayer.setUrl(activeLayer === "satelite" ? MAP_URLS.SATELITE : MAP_URLS.ROAD_MAP)
        }
    }

    const initMapData = () => {
        var markerOptions = {
            clickable: true,
            draggable: false,
            icon: markerIcon,
        };
        // console.log(request)

        const center = { lat: request.field_lat, lng: request.field_lng };
        let marker = new L.marker(center, markerOptions);
        marker.on('click', function () {
            map.flyTo(center, Math.min(map.getZoom() + 1, map.getMaxZoom()));
        });
        const completedStatus = request.status_history?.find(status => status.updated_status === STATUS.COMPLETED);
        if (completedStatus && completedStatus.pilot_lat && completedStatus.pilot_lng) {
            const pilotMarkerOptions = {
                clickable: true,
                draggable: false,
                icon: PilotIcon,
            };
            const pilotLocation = { lat: completedStatus.pilot_lat, lng: completedStatus.pilot_lng };
            let pilotMarker = new L.marker(pilotLocation, pilotMarkerOptions);
            pilotMarker.addTo(map);
        }
        map?.addLayer(marker);
        const bounds = L.latLngBounds([center]);
        map?.fitBounds(bounds, { maxZoom: 16 })
    }
    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            mapContainerRef.current.requestFullscreen().catch(err => {
                console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
        } else {
            document.exitFullscreen();
        }
    }



    useEffect(() => {
        console.log(state.request)
        Loading.set(true)
        getRequestDetails()
        if(userDetails.bhumeet_role == 'Admin' || userDetails.bhumeet_role == 'Customer support engineer' || userDetails.bhumeet_role == 'Telecaller'){

            getAllRequestIssueByID(state.request.id || state.request.Data.reqid)
        }


    }, [])

    useEffect(() => {
        setRefresh((prev) => prev + 1);

    }, [lastRecord])

    useEffect(() => {
        console.log(refresh)
    },[refresh])

    useEffect(() => {
        console.log(state)
        if (request.field_lat && request.field_lng) {
            initMapData();

            // console.log(isSprayingService || isSurveyService)
            const InitialfieldData = [
                { label: 'Sales By', value: request?.sales_by },
                { label: 'DSP Name', value: request?.owner?.name },
                { label: 'Request Number', value: request?.req_number },
                { label: 'Customer Name', value: request?.user?.name },
                { label: 'Location', value: request?.location_address, overflow: true },
                { label: 'Contact No.', value: request?.user?.mobile_number },
                // { label: 'Service', value: state.request.type },
                { label: 'Service Location', value: request?.field_address, overflow: true },
                (isSprayingService || isSurveyService) && { label: 'Drone Type', value: request?.drone_type },
                isSprayingService && { label: 'Crop', value: request?.crops?.English || request?.crop_name },
                isSprayingService && { label: 'Agro Chemicals', value: request?.pesticides },
                (isSprayingService || isSurveyService) && { label: 'Drone UIN', value: request?.drone_uin },
                isTrainingService && { label: 'Date', value: request?.date_created ? dateFormat(request.date_created, "dd/mm/yyyy") : "-" },
                isTrainingService && { label: 'Time', value: request?.date_created ? dateFormat(request.date_created, "hh:MM TT") : "-" },
                (isSprayingService || isSurveyService) && { label: 'Date', value: request?.time ? dateFormat(request.time, "dd/mm/yyyy") : "-" },
                // (isSprayingService || isSurveyService) && { label: 'Time', value: request?.time ? dateFormat(request.time, "hh:MM TT") : "-" },
                (isSprayingService || isSurveyService) && {
                    label: 'Pilot',
                    value: request?.pilot_name ? reduceLongName(request.pilot_name, 20) : "-"
                },
                {
                    label: `Status`,
                    value: `${request?.status} ${request.status === STATUS.PAID ? `(${request.payment_method === "Offline" ? "Cash" : "UPI"})` : ""}`
                },
                isTrainingService && { label: 'Price', value: request?.price ? request.price + " Rs." : "-" },
                (isSprayingService) && { label: request?.price_by === "acre" ? `Requested Area` : "Requested No of Tank ", value: request?.price_by === "tank" ? request?.field_area : request?.price_by === "acre" ? Number(squareKilometersToAcres(request?.field_area)).toFixed(2) + " Acre" : "-" },
                (isSurveyService) && { label: 'Requested Area', value: request?.field_area ? Number(request?.field_area).toFixed(4) + " Sq/km" : "-" },
                ((isSprayingService && request?.service_completed_area) && {
                    label: request.price_by === "acre" ? "Completed Area" : "Completed No Of Tank", value: (request.price_by === "acre" ? Number(squareKilometersToAcres(request.service_completed_area)).toFixed(4) + " Acre" : request.service_completed_area) || "-"
                })
            ].filter(Boolean);
            console.log(InitialfieldData)
            setFieldData(InitialfieldData)
        }

        Loading.set(false);
        if(callHistory.length > 0 && state.request.Data) checkExistingCalls(callHistory)

        if(![STATUS.CANCELLED, STATUS.COMPLETED, STATUS.PAID].includes(request?.status)) {
            setShowCancelButton(true);
        } else {
            setShowCancelButton(false);
        }
    }, [request])
    console.log("state : ", state.request.showCancel)
    return (<><MainContentWrapper containerStyle={{ overflow: "auto" }} header={['Admin','Telecaller','Customer support engineer'].includes(userDetails.bhumeet_role) && state.request.show ?`Calling History`:undefined} rightContent={
        <>
            {
                <OrderCancelModal
                    open={openCancelOrderModal}
                    onClose={() => {
                        setOpenCancelOrderModal(false);
                    }}
                    onOrderCancel={async (cancelOrderReason) => {
                        if (request?.is_bes_linked) {
                            Popup.alert("BES linked", "Are you want to debit BES incentive ?", "WARNING", () => cancelRequestFunction(request.id, cancelOrderReason, true), null, "Yes", () => cancelRequestFunction(request.id, cancelOrderReason, false), "No")
                        }
                        else cancelRequestFunction(request.id, cancelOrderReason, false)
                    }}
                />
            }
            {((userDetails.bhumeet_role == 'Admin' || userDetails.bhumeet_role == 'Customer support engineer' || userDetails.bhumeet_role == 'Telecaller') && state.request.show) && 
            <div  style={{ display: "flex", justifyContent: "space-between", gap: "5px"}}>
                {showCancelButton && state?.request?.showCancel ?
                    <Button
                    // isDisabled={!cancelNote}
                        text={"Cancel"}
                        className={"btn-large"}
                        onClick={() => {
                        setOpenCancelOrderModal(true);
                        }}
                    />
                : null
                }
            <div style={{ display: "flex", justifyContent: "space-between", gap: "5px" }}>
            <Button style={{ whiteSpace: "nowrap", width: "100px", height: "100%" }}
                type="submit"
                // icon={Plus}

                text={"Report Issue"}
                onClick={() => {
                    if(AllrequestIssue.length >= 1){
                        navigate('/issue/requestIssueDetail', { state: { issueID: AllrequestIssue[0].id, IssueDetail: AllrequestIssue[0] } });
                    }else{
                        setCreateIssue(!createIssue); }}
                    }
                    
            />
            </div>
        </div>
            }
            
        </>
    } >

        
        {createIssue && <CreateRequestIssue existingRequest={AllrequestIssue} data={state.request} onClose={() => { setCreateIssue(false);getAllRequestIssueByID(state.request.id || state.request.Data.reqid) }} open={createIssue} />}


        {(state.request.show) &&
            <>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    {opencallHistory && <AddcallHistory open={opencallHistory} data={state.request.Data} onClose={() => {
                        setopencallHistory(false);
                        setRefresh((prev) => prev + 1);
                        console.log("Closed")
                    }} />
                    }




                </div>
                <CallHistoryTable lastRecord={lastRecord} key={refresh} state={state} campid={campid} onClose={() => { setCampid(null); checkExistingCalls(callHistory) }} callhistoryData={(e) => { setcallHistory(e) }} />

            </>
        }





        <div style={{ marginTop: "10px", background: "white", height: "100%", width: "100%", }}>

            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "8%",
                    padding: "20px 30px",
                    borderBottom: "1px solid rgba(128, 128, 128, 0.24)",
                    fontSize: "1rem",
                    display: "flex",
                    justifyContent: "space-between", // This aligns left and right
                    alignItems: "center",
                    color: "#1E1E1E",
                    fontWeight: "500",
                }}
            >
                {/* Left content */}
                <div>Request Details</div>
            </div>



            <div style={{ background: "white", position: "relative", display: "flex", width: "100%",height:"92%",}}>
                <div style={{ width: "80%", height: "auto", borderRight: "1px solid #8080803d",overflowY:"scroll" }}>
                    <div style={{ position: "relative", padding: "20px 30px", height: "auto", width: "100%", }}>
                        <div className='request_fields_wrapper'>
                            {fieldData.map((field, index) => (
                                <Field key={index} label={field.label} value={field.value} overflow={field.overflow}

                                    onCallClick={(e,l) => handleCallClick(e,l)} />
                            ))}
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                        <div style={{ width: currentWidth<1500?"45%":"40%", margin: "25px 25px 30px 25px" }}>
                            {request?.invoice && <RequestDiscount
                                hideToggle
                                oldRequest={request || {}}
                                request={request}
                            />}

                        </div>
                        <div style={{ width: "50%", }} className=''>
                            <div ref={mapContainerRef} style={{ position: "relative", zIndex: 999, right: 10, bottom: 0, width: "450px", height: "200px", padding: "5px", borderRadius: "8px" }}>
                                <Map
                                    setBaseLayerToState={(bL) => {
                                        baseLayer = bL
                                    }}
                                    initZoom={6}
                                    initCenter={center}
                                    handleMapClick={() => { }}
                                    maxZoom={25}
                                    style={{
                                        height: "100%",
                                        borderRadius: "10px",
                                        boxShadow: '0px 0px 8.9px 3px rgba(114, 114, 114, 0.15)',
                                    }}
                                    mapInitialized={(map) => {
                                        initMap(map);
                                    }}
                                />
                                <div style={{ border: 'solid 1px rgb(102, 102, 102, 0.3)', height: '25px', backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '5px', cursor: 'pointer', zIndex: '999', position: "absolute", right: "10px", bottom: '24px' }}
                                    onClick={switchBaseLayer}>
                                    <img style={{ width: '80px', height: '25px', borderRadius: '4px' }} src={activeBaseLayer === "satelite" ? roadMapView : sateliteView} />
                                </div>
                                <div style={{ position: "absolute", bottom: -10, left: "15px", height: '50px', zIndex: '999', cursor: "pointer" }}>
                                    <img src={isFullScreen ? collapseIcon : fullScreenIcon} onClick={toggleFullScreen} alt="" width={isFullScreen ? "25px" : "20px"} height={"25px"} />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                            <div className="w-[20%]">
                        <VerticalStepper 
                        steps={steps} 
                        requestId={request?.id} 
                        comments={comments}  
                        isLoading={isLoading}
                        isCommentEditable={!user?.is_pdrl_admin}
                        />
                        </div>


            </div>
        </div>
    </MainContentWrapper > </>);
};
export default ViewRequestDetails;